export default __webpack_public_path__ + "static/media/attention.987ed38c.svg";